import {Injectable} from '@angular/core';
import {LocalStorageService} from './local-storage.service';
import {LoginResponse} from '../model/login-response';
import {TokenService} from './token.service';
import {TokenBody} from '../model/token-body';
import {TranslateService} from '../../../../../node_modules/@ngx-translate/core';

@Injectable()
export class AuthorizationService {

  constructor(private localStorageService: LocalStorageService, private tokenService: TokenService, private translate: TranslateService) {
  }

  public isUserLoggedIn(): boolean {
    return this.localStorageService.doesTokenExist();
  }

  public initSession(response: LoginResponse) {
    const decodedToken: TokenBody = this.tokenService.decodeToken(response.accessToken);
    this.localStorageService.setRefreshToken(response.refreshToken);
    this.localStorageService.setToken(response.accessToken);
    this.localStorageService.setLoginId(decodedToken.Id);
    this.localStorageService.setExpire(decodedToken.exp);
    this.localStorageService.setFirstname(decodedToken.FirstName);
    this.localStorageService.setLastname(decodedToken.LastName);
    this.localStorageService.setEmail(decodedToken.Username);
    this.localStorageService.setCulture(decodedToken.Culture);
    this.localStorageService.setCountry(decodedToken.Country);
    this.translate.use(this.localStorageService.getCulture()).subscribe();
  }

  public clearSession() {
    this.localStorageService.deleteRefreshToken();
    this.localStorageService.deleteToken();
    this.localStorageService.deleteExpire();
    this.localStorageService.deleteLoginId();
    this.localStorageService.deleteFirstname();
    this.localStorageService.deleteLastname();
    this.localStorageService.deleteEmail();
  }
}
